import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopGradeClass(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_grade_class" popSize="s">
      <h2 className="pop_tit">수시 상품 등록</h2>
      <div className="content_container scroll">
        <table className="com_board_list type_row">
          <colgroup>
            <col width="148" />
          </colgroup>
          <tbody>
            <tr>
              <th>과목명</th>
              <td>
                <select className="select">
                  <option value="논술">논술</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>상품명</th>
              <td>
                <select className="select">
                  <option value="논술 60">논술 60</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>코드</th>
              <td className="td_left">
                <input type="text" className="input" />
              </td>
            </tr>
            <tr>
              <th>1회 수업시간</th>
              <td className="td_left">
                <div className="check">
                  <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                  <label htmlFor="rdo2_1">80분</label>
                  <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                  <label htmlFor="rdo2_2">90분</label>
                </div>
              </td>
            </tr>
            <tr>
              <th>수업 체크 방법</th>
              <td className="td_left">
                <div className="check">
                  <input type="radio" name="rdo_3" id="rdo3_1" className="com_chk circle" />
                  <label htmlFor="rdo3_1">보고서 작성</label>
                  <input type="radio" name="rdo_3" id="rdo3_2" className="com_chk circle" />
                  <label htmlFor="rdo3_2">수업체크만</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="com_btn_wrap right">
          <button className="com_btn gray xxs">상품 삭제</button>
        </div>
        <table className="com_board_list type_row">
          <colgroup>
            <col width="148" />
          </colgroup>
          <tbody>
            <tr>
              <th>수업 방법</th>

              <td className="td_left">
                <div className="check">
                  <input type="radio" name="rdo4" id="rdo4_1" className="com_chk circle" />
                  <label htmlFor="rdo4_1">1:1 수업</label>
                  <input type="radio" name="rdo4" id="rdo4_2" className="com_chk circle" />
                  <label htmlFor="rdo4_2">1:2수업</label>
                </div>
              </td>
            </tr>
            <tr>
              <th>수업 단가</th>
              <td className="td_left">
                <input type="text" className="input" defaultValue={`200,000`} />
              </td>
            </tr>
            <tr>
              <th>지급 방법</th>
              <td className="td_left">
                <div className="check">
                  <input type="radio" name="rdo5" id="rdo5_1" className="com_chk circle" />
                  <label htmlFor="rdo5_1">%지분</label>
                  <input type="radio" name="rdo5" id="rdo5_2" className="com_chk circle" />
                  <label htmlFor="rdo5_2">정액제</label>
                </div>
              </td>
            </tr>
						{/* 20250218 퍼블 수정 */}
            <tr>
              <th>지급 메인</th>
              <td className="td_left">
								<div className="com_flex_row">
									메인
                   <input type="text" className="input wxs" defaultValue={`200,000`} />
									서브
                   <input type="text" className="input wxs" defaultValue={`200,000`} />
								</div>
              </td>
            </tr>
            <tr>
              <th>지급 서브</th>
              <td className="td_left">
								<div className="com_flex_row">
									메인
                   <input type="text" className="input wxs" defaultValue={`200,000`} />
									서브
                   <input type="text" className="input wxs" defaultValue={`200,000`} />
								</div>
              </td>
            </tr>
            <tr>
              <th>관세 여부</th>
              <td className="td_left">
                <div className="check">
                  <input type="radio" name="rdo6" id="rdo6_1" className="com_chk circle" />
                  <label htmlFor="rdo6_1">과세</label>
                  <input type="radio" name="rdo6" id="rdo6_2" className="com_chk circle" />
                  <label htmlFor="rdo6_2">비과세</label>
                </div>
              </td>
            </tr>
            <tr>
              <th>상태</th>
              <td className="td_left">
                <div className="check">
                  <input type="radio" name="rdo7" id="rdo7_1" className="com_chk circle" />
                  <label htmlFor="rdo7_1">사용</label>
                  <input type="radio" name="rdo7" id="rdo7_2" className="com_chk circle" />
                  <label htmlFor="rdo7_2">미사용</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="tit">보고서 등록</div>
        <ul className="list">
          <li className="item">
            <span className="num">1</span>
            <select className="select">
              <option value="보고서 선택">보고서 선택</option>
            </select>
            <button className="btn_minus_gray" />
          </li>
          <li className="item">
            <span className="num">2</span>
            <select className="select">
              <option value="보고서 선택">보고서 선택</option>
            </select>
            <button className="btn_minus_gray" />
          </li>
        </ul>
        <hr className="com_divider" />
				{/* 20250218 퍼블 수정 */}
        <div className="com_btn_wrap right">
          <button className="com_btn xs black btn_plus_orange">보고서 추가</button>
        </div>
        <hr className="com_divider" />
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopGradeClass;
